function isCustomTypeModel(input) {
  return typeof input === "object" && input !== null && "json" in input;
}
export {
  isCustomTypeModel
};
//# sourceMappingURL=isCustomTypeModel.js.map
